<template>
	<v-container fluid>
		<v-layout mb-3>
			<h3>Limity finansowania na kraj dla poszczególnych form prawnych </h3>

		</v-layout>
		<v-layout row wrap ml-3>
			<v-flex xs6 v-for="country in countries" :key="country">
				<v-flex mb-3>
					<h4>{{country}}</h4>
				</v-flex>
				<v-flex xs11 mb-4>
					<v-data-table
						:items="perCountryPerLegalFormData[country]"
						:headers="tableHeaders"
						class="elevation-1"
						hide-actions>
						<template slot="items" slot-scope="props">
							<td>{{ props.item.legalFormName }}</td>
							<td>{{ formatMoney(props.item.minFunding) }}</td>
							<td>{{ formatMoney(props.item.maxFunding) }}</td>
							<td>
								<v-icon
									small
									class="mr-2"
									@click="openInputDialog(props.item)">
									edit
								</v-icon>
							</td>
						</template>
					</v-data-table>
				</v-flex>
			</v-flex>
		</v-layout>
		<v-dialog v-model="showInputDialog" persistent max-width="500px">
			<v-card>
				<v-card-title>
					<v-flex>
						<span class="headline">Podaj limity dofinansowania</span>
						<v-container fluid>
							<v-layout pl-3>
								<v-flex xs3>
									Państwo:
								</v-flex>
								<v-flex>
									{{this.editedItem.countryName}}
								</v-flex>
							</v-layout>
							<v-layout pl-3>
								<v-flex xs3>
									Forma prawna:
								</v-flex>
								<v-flex>
									{{this.editedItem.legalFormName}}
								</v-flex>
							</v-layout>
						</v-container>
					</v-flex>
				</v-card-title>
				<v-card-text>
					<v-layout>
						<v-flex xs5>
							<egranty-number-input-field
								label="Minimalna kwota dofinansowania"
								for="financial-limits-per-legal-form-min-funding"
								id="financial-limits-per-legal-form-min-funding"
								v-model="minFunding"
								suffix=" PLN"
								placeholder="np. 25 000.00"
							></egranty-number-input-field>
						</v-flex>
					</v-layout>
					<v-layout>
						<v-flex xs5>
							<egranty-number-input-field
								label="Maksymalna kwota dofinansowania"
								for="financial-limits-per-legal-form-max-funding"
								id="financial-limits-per-legal-form-max-funding"
								v-model="maxFunding"
								suffix=" PLN"
								placeholder="np. 100 000.00"
							></egranty-number-input-field>
						</v-flex>
					</v-layout>
					<div v-if="showErrorMessage" style="color:red;">
						{{errorMessage}}
					</div>
				</v-card-text>
				<v-card-actions>
					<v-spacer/>
					<v-btn flat color="primary" @click="closeInputDialogWithoutSaving">Anuluj</v-btn>
					<v-btn flat color="primary" @click="closeInputDialog">Zapisz</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
	import EgrantyNumberInputField from "../../../../genericComponents/EgrantyNumberInputField";
	import {FinancialSettings} from "../../../../api/generated/FinancialSettings";
	import {Numbers} from "../../../../utils/Numbers";

	export default {
		name: "FinancialLimitsPerLegalForm",
		components: {EgrantyNumberInputField},
		mixins: [Numbers],
		computed: {
			contestId() {
				return this.$route.params.id;
			},

		},

		mounted () {
			this.removeEmptyTableLoading();
		},

		methods: {

			openInputDialog(item) {
				this.showInputDialog = true;
				this.editedItem = item;
				this.minFunding = item.minFunding;
				this.maxFunding = item.maxFunding;
			},

			closeInputDialogWithoutSaving() {
				this.showInputDialog = false;
				this.showErrorMessage = false;
				this.editedItem = {};
			},

			closeInputDialog() {
				if((parseFloat(this.minFunding) == parseFloat(this.maxFunding)) || ((this.minFunding || 0) == (this.maxFunding || 0))){
					this.errorMessage = "Minimalna i maksymalna kwota dofinansowania nie mogą być równe.";
					this.showErrorMessage = true;
					
					return;
				}
				if (this.minFunding === null || this.minFunding === "" || this.maxFunding === null || this.maxFunding === "" || parseFloat(this.minFunding) > parseFloat(this.maxFunding)) {
					this.errorMessage = "Minimalna kwota dofinansowania nie może być większa od maksymalnej.";
					this.showErrorMessage = true;
					return;
				}
				this.showErrorMessage = false;
				this.showInputDialog = false;
				this.editedItem.minFunding = this.minFunding;
				this.editedItem.maxFunding = this.maxFunding;
				this.editedItem = {};
			},

			refresh() {
				FinancialSettings.getFinancialLimitsPossibilities(
					this,
					this.contestId,
					true,
					this.moduleNumber ? this.moduleNumber : "",
					response => {
						this.properties = response;
						this.localProperties = this.nullifyProperties(this.properties);
						let names = new Set();
						this.localProperties.forEach(prop => {
							names.add(prop.countryName);
						});

						this.countries = [];
						for (let value of names.values()) {
							this.countries.push(value);
						}

						for (let name of this.countries) {
							this.perCountryPerLegalFormData[name] = this.localProperties
								.filter(value => {
									return value.countryName === name;
								}).sort((a, b) => a.legalFormId - b.legalFormId);
						}
					},
				);
			},

			getValuesToSave(){
				return this.localProperties;
			},
			nullifyProperties(properties) {
				return properties.map(property => {
					let minFunding = null, maxFunding = null;
					if (property.minFunding !== null) {
						minFunding = property.minFunding;
					}
					if (property.maxFunding !== null) {
						maxFunding = property.maxFunding;
					}
					return {
						countryId: property.countryId,
						countryName: property.countryName,
						legalFormId: property.legalFormId,
						legalFormName: property.legalFormName,
						maxFunding: maxFunding,
						minFunding: minFunding,
					};
				});
			},
			denullifyProperties(properties) {
				return properties.map(property => {
					let minFunding = null, maxFunding = null;
					if (property.minFunding !== null && property.minFunding !== "") {
						minFunding = property.minFunding;
					}
					if (property.maxFunding !== null && property.maxFunding !== "") {
						maxFunding = property.maxFunding;
					}
					return {
						countryId: property.countryId,
						countryName: property.countryName,
						legalFormId: property.legalFormId,
						legalFormName: property.legalFormName,
						maxFunding: maxFunding,
						minFunding: minFunding,
					};
				});
			},

			validate() {
				let errorMessages = [];
				for (let property of this.localProperties) {
					if(property.maxFunding == null || property.maxFunding==0){
						if(this.moduleNumber == null || this.moduleNumber ==0){
							errorMessages.push("Maksymalna kwota dofinansowania musi być uzupełniona dla kraju " + property.countryName + " dla formy prawnej " + property.legalFormName + ".");
						} else {
							errorMessages.push("Maksymalna kwota dofinansowania musi być uzupełniona dla kraju " + property.countryName + " w module " + this.moduleNumber + " dla formy prawnej " + property.legalFormName + " .");
						}
					}
				}
				if (errorMessages.length > 0) {
					this.$emit("error", errorMessages);
					return false;
				}
				return true;
			},

			removeEmptyTableLoading () {
				let el = document.querySelector(".v-datatable__progress");
				if(el && el.parentNode){
					el.parentNode.removeChild(el);
				}
			},


		},

		created() {
			this.refresh();
		},

		data() {
			return {
				properties: [],
				localProperties: [],

				countries: [],

				perCountryPerLegalFormData: {},
				editedItem: {},
				minFunding: '',
				maxFunding: '',

				tableHeaders: [
					{text: "Forma prawna", sortable: false},
					{text: "Wartość minimalna", sortable: false},
					{text: "Wartość maksymalna", sortable: false},
					{text: "Akcje", sortable: false},
				],

				showInputDialog: false,
				showErrorMessage: false,
				errorMessage: "Minimalna kwota dofinansowania nie może być większa od maksymalnej."
			};
		},

		props: {
			legalForms: Array,
			moduleNumber: {type: Number, default: null}
		},

	};
</script>

<style scoped>

</style>
